import React from 'react';
import ImageComponent from '../../atoms/image-component/image-component';
import styles from './hero.module.scss';

export type HeroProps = {
  altText: string;
  src: string;
  backgroundColor?: string;
  id?: string;
};

export default function Hero(hero: HeroProps) {
  return (
    <section className={styles[`hero`]} id={hero.id}>
      <div
        className={styles[`hero-background`]}
        style={{ backgroundColor: hero.backgroundColor ? hero.backgroundColor : '#F0F0F0' }}
      >
        <ImageComponent src={hero.src} altText={hero.altText} />
      </div>
    </section>
  );
}
